/* Public opening hours only. No request to Google or the private service. */
(() => {
  if (customElements.get('aa-google-hours')) return;
  const copy = {
    de: {heading:'Öffnungszeiten in der Zwischensaison',title:'Öffnungszeiten',today:'Heute',special:'Sonderzeiten',more:'Weitere Tage anzeigen',less:'Weitere Tage ausblenden',next:'Nächste Öffnung',notice:'Kurzfristige Änderungen sind möglich. Bitte rufen Sie im Zweifel vor Ihrem Besuch kurz bei uns an.',unavailable:'Aktuelle Öffnungszeiten konnten nicht sicher aktualisiert werden. Bitte prüfen Sie Google Maps oder rufen Sie vor Ihrem Besuch an.'},
    en: {heading:'Off-season opening hours',title:'Opening hours',today:'Today',special:'Special hours',more:'Show other days',less:'Hide other days',next:'Next opening',notice:'Opening hours may change at short notice. If in doubt, please call us before your visit.',unavailable:'Current opening hours could not be reliably updated. Please check Google Maps or call before your visit.'},
    it: {heading:'Orari di apertura in bassa stagione',title:'Orari di apertura',today:'Oggi',special:'Orari speciali',more:'Mostra gli altri giorni',less:'Nascondi gli altri giorni',next:'Prossima apertura',notice:'Gli orari possono variare con breve preavviso. In caso di dubbio, chiamateci prima della visita.',unavailable:'Non è stato possibile aggiornare gli orari in modo affidabile. Consultate Google Maps o chiamateci prima della visita.'},
    ar: {heading:'ساعات العمل خلال الموسم الانتقالي',title:'ساعات العمل',today:'اليوم',special:'ساعات خاصة',more:'عرض الأيام الأخرى',less:'إخفاء الأيام الأخرى',next:'موعد الفتح القادم',notice:'قد تتغير ساعات العمل بإشعار قصير. في حال الشك، يرجى الاتصال بنا قبل زيارتكم.',unavailable:'تعذر تحديث ساعات العمل الحالية بشكل موثوق. يرجى التحقق من خرائط Google أو الاتصال بنا قبل الزيارة.'}
  };
  const branches = {
    'seefeld-retail': {location:'locations/7793954885805038769',address:'Klosterstraße 608 · 6100 Seefeld in Tirol',extra:{de:'In den Klosterarkaden',en:'In the Klosterarkaden',it:'Nelle Klosterarkaden',ar:'داخل Klosterarkaden'}},
    'innsbruck-retail': {location:'locations/8270878481709665659',address:'Hofgasse 2 · 6020 Innsbruck'},
    'zell-retail': {location:'locations/12864871436643473412',address:'Bahnhofstraße 15 · 5700 Zell am See'}
  };
  const iso = s => typeof s === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/.test(s) && Number.isFinite(Date.parse(s));
  const safeText = s => typeof s === 'string' && s.length <= 500;
  const dateOK = s => typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s) && Number.isFinite(Date.parse(s)) && new Date(s).toISOString().slice(0,10) === s;
  const minute = s => typeof s === 'string' && /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(s) ? Number(s.slice(0,2))*60+Number(s.slice(3)) : s === '24:00' ? 1440 : NaN;
  const clock = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Vienna',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
  const compactDates = Object.fromEntries(Object.entries({de:'de-DE',en:'en-GB',it:'it-IT',ar:'ar'}).map(([key,locale]) => [key,new Intl.DateTimeFormat(locale,{timeZone:'Europe/Vienna',calendar:'gregory',weekday:'short',day:'2-digit',month:'2-digit'})]));
  const compactDate = (date,locale) => compactDates[locale].format(new Date(date+'T12:00:00Z'));
  function local(ms) {
    const p = Object.fromEntries(clock.formatToParts(ms).map(x => [x.type,x.value]));
    return {date:`${p.year}-${p.month}-${p.day}`,minutes:Number(p.hour)*60+Number(p.minute)};
  }
  function intervalsOK(d) {
    if (!Array.isArray(d.intervals) || typeof d.closed !== 'boolean' || d.closed !== (d.intervals.length === 0)) return false;
    let end = -1;
    return d.intervals.every(i => {
      const a=minute(i?.open),b=minute(i?.close);
      if (!(a>=0 && a<b && b<=1440 && a>=end)) return false;
      end=b; return true;
    });
  }
  // Round-trip Vienna wall time. No guessed offset at DST gaps or repeated hours.
  function instant(date,time) {
    const m=minute(time),base=Date.parse(date+'T00:00:00Z')+m*60000,found=[];
    for (let offset=60;offset<=120;offset+=60) {
      const t=base-offset*60000,p=local(t);
      if(p.date===date && p.minutes===m) found.push(t);
    }
    return found.length===1 ? found[0] : null;
  }
  function valid(p,v,branch,locale,now) {
    if (!(p?.schema_version===1 && p.source==='google-business-profile' && p.branch===branch && p.mapping_verified===true && p.timezone==='Europe/Vienna'
      && iso(p.fetched_at) && iso(p.expires_at) && iso(v?.render_until)
      && Date.parse(p.fetched_at)<=now && Date.parse(p.expires_at)>now
      && Date.parse(p.expires_at)>Date.parse(p.fetched_at) && Date.parse(p.expires_at)-Date.parse(p.fetched_at)<=900000
      && Date.parse(v.render_until)>now && Date.parse(v.render_until)<=Date.parse(p.expires_at)
      && v.freshness==='fresh' && v.locale===locale && ['open','closed','temporarily_closed','permanently_closed'].includes(v.state)
      && safeText(v.status_text) && p.is_mock!==true
      && Object.hasOwn(branches,branch) && v.branch===branch && v.location===branches[branch].location
      && v.timezone==='Europe/Vienna' && v.source==='google-business-profile'
      && v.is_mock===false && v.binding_verified===true && v.mapping_verified===true
      && Array.isArray(v.days) && v.days.length===7)) return false;
    const today=local(now).date;
    return v.days.every((d,n) => d && dateOK(d.date) && d.date===new Date(Date.parse(today)+n*86400000).toISOString().slice(0,10)
      && safeText(d.weekday) && safeText(d.date_label) && safeText(d.text)
      && ['regular','special','business_status'].includes(d.source) && intervalsOK(d));
  }
  function nextOpening(v,now) {
    if(v.state!=='closed' || v.open_now!==false || v.time_status!=='known' || v.business_status!=='OPEN') return null;
    for(const d of v.days) for(const i of d.intervals) {
      const a=instant(d.date,i.open);
      // An earlier uncertain interval prevents claiming a later one is next.
      if(a===null) return null;
      if(a>now) return {day:d,time:i.open};
    }
    return null;
  }
  const members=new Set();
  const sectionID=el=>{
    const wrapper=el.closest('[id^="shopify-section-"]');
    const id=wrapper?.id.slice('shopify-section-'.length);
    return id && /^[\w-]{1,200}$/.test(id) && (!el.dataset.sectionId || el.dataset.sectionId===id) ? id : null;
  };
  function requestURL(href,ids){
    const url=new URL(href);
    url.hash='';url.searchParams.delete('section_id');url.searchParams.delete('sections[]');
    url.searchParams.set('sections',ids.join(','));
    return url;
  }
  // Extract only our JSON script text; never parse/insert response HTML into the DOM.
  function extractPayload(html,el,id){
    if(typeof html!=='string' || html.length>1000000)throw Error('section_missing');
    const found=[];
    for(const match of html.matchAll(/<script\b([^>]*)>([\s\S]*?)<\/script\s*>/gi)){
      const attrs=Object.create(null);
      for(const a of match[1].matchAll(/([\w-]+)\s*=\s*(["'])(.*?)\2/g)){
        if(Object.hasOwn(attrs,a[1]))throw Error('duplicate_attribute');
        attrs[a[1]]=a[3];
      }
      if(attrs.type!=='application/json' || attrs['data-hours-data']!=='v1')continue;
      if(attrs['data-hours-branch']!==el.dataset.branch || attrs['data-hours-locale']!==el.dataset.locale)continue;
      if(attrs['data-hours-section']!==id || attrs['data-hours-theme']!==el.dataset.themeId)throw Error('context_mismatch');
      found.push(JSON.parse(match[2]));
    }
    if(!found.length)throw Error('payload_missing');
    if(found.some(p=>JSON.stringify(p)!==JSON.stringify(found[0])))throw Error('conflicting_payloads');
    return found[0];
  }
  async function limitedJSON(response){
    if(!response.ok || !/application\/json/i.test(response.headers.get('content-type')||''))throw Error('response');
    if(Number(response.headers.get('content-length'))>1000000)throw Error('size');
    const reader=response.body.getReader(),decoder=new TextDecoder();let size=0,text='';
    try{
      while(true){const {done,value}=await reader.read();if(done)break;
        size+=value.byteLength;if(size>1000000)throw Error('size');text+=decoder.decode(value,{stream:true});}
      return JSON.parse(text+decoder.decode());
    }finally{await reader.cancel().catch(()=>{});}
  }
  const refresh={timer:null,controller:null,epoch:0,failures:0,due:0,cursor:0,
    plan(){
      clearTimeout(this.timer);
      if(document.hidden || !members.size)return;
      this.timer=setTimeout(()=>this.run(),Math.max(0,this.due-Date.now()));
    },
    async run(){
      if(document.hidden || this.controller || !members.size)return;
      if(Date.now()<this.due){this.plan();return;}
      const available=[...new Set([...members].map(sectionID).filter(Boolean))];
      if(!available.length){this.due=Date.now()+60000;this.plan();return;}
      // At most five sections and one request per page per minute, even with many instances.
      const ids=Array.from({length:Math.min(5,available.length)},(_,n)=>available[(this.cursor+n)%available.length]);
      this.cursor=(this.cursor+ids.length)%available.length;
      const targets=[...members].filter(el=>ids.includes(sectionID(el)) && /^\d+$/.test(el.dataset.themeId||''));
      const href=window.location.href,url=requestURL(href,ids),epoch=++this.epoch;
      if(url.origin!==window.location.origin)return;
      const controller=new AbortController();this.controller=controller;
      this.due=Date.now()+60000;
      let timeout;
      try{
        const work=(async()=>{
          const response=await fetch(url.href,{method:'GET',mode:'same-origin',credentials:'same-origin',cache:'no-store',redirect:'error',signal:controller.signal,headers:{Accept:'application/json'}});
          return limitedJSON(response);
        })();
        const data=await Promise.race([work,new Promise((_,reject)=>{timeout=setTimeout(()=>{controller.abort();reject(Error('timeout'));},10000);})]);
        if(epoch!==this.epoch || document.hidden || window.location.href!==href)return;
        let failed=false;
        for(const el of targets){
          if(!members.has(el))continue;
          try{if(!el.accept(extractPayload(data[sectionID(el)],el,sectionID(el))))failed=true;}
          // An unverified section response cannot revoke a verified snapshot.
          catch{failed=true;el.render();el.schedule();}
        }
        this.failures=failed?Math.min(4,this.failures+1):0;
      }catch{
        if(epoch===this.epoch){this.failures=Math.min(4,this.failures+1);targets.forEach(el=>el.render());}
      }finally{
        clearTimeout(timeout);
        if(epoch===this.epoch){
          this.controller=null;this.due=Date.now()+Math.min(300000,60000*2**this.failures);this.plan();
        }
      }
    },
    visibility(){
      clearTimeout(this.timer);
      if(document.hidden){this.epoch++;this.controller?.abort();this.controller=null;}
      else{members.forEach(el=>el.tick());this.plan();queueAlign();}
    }
  };
  document.addEventListener('visibilitychange',()=>refresh.visibility());
  // Group by actual geometry, never DOM order; works for RTL and wrapped rows.
  function visualRows(items){
    const rows=[];
    for(const item of [...items].sort((a,b)=>a.rect.top-b.rect.top||a.rect.left-b.rect.left)){
      const row=rows.find(r=>Math.abs(r[0].rect.top-item.rect.top)<=3 && r.every(x=>x.rect.right<=item.rect.left+1 || item.rect.right<=x.rect.left+1));
      if(row)row.push(item);else rows.push([item]);
    }
    return rows.filter(r=>r.length>1);
  }
  let alignmentFrame=0;
  const restored=new Map();
  function rememberSet(el,property,value){
    if(!restored.has(el))restored.set(el,new Map());
    const props=restored.get(el);
    if(!props.has(property))props.set(property,[el.style.getPropertyValue(property),el.style.getPropertyPriority(property)]);
    el.style.setProperty(property,value);
  }
  function resetAlignment(){
    for(const [el,props] of restored)for(const [key,[value,priority]]of props){
      if(value)el.style.setProperty(key,value,priority);else el.style.removeProperty(key);
    }
    restored.clear();
  }
  function align(){
    alignmentFrame=0;resetAlignment();
    if(!window.matchMedia('(min-width: 600px)').matches)return;
    const containers=new Map();
    for(const el of members){
      const card=el.closest('.text-column'),container=card?.closest('.container');
      if(!card || !container || el.liveBox.hidden || !el.getClientRects().length)continue;
      if(!containers.has(container))containers.set(container,[]);
      const entries=containers.get(container);
      if(entries.some(x=>x.card===card))continue;
      entries.push({el,card,rect:card.getBoundingClientRect()});
    }
    for(const entries of containers.values())for(const row of visualRows(entries)){
      const titles=row.map(x=>x.card.querySelector('h3'));
      if(titles.every(Boolean)){
        const top=Math.max(...titles.map(x=>x.getBoundingClientRect().top));
        for(const title of titles){
          const delta=top-title.getBoundingClientRect().top;
          rememberSet(title,'margin-block-start',`${parseFloat(getComputedStyle(title).marginBlockStart)+delta}px`);
        }
        const height=Math.max(...titles.map(x=>x.getBoundingClientRect().height));
        titles.forEach(x=>{rememberSet(x,'box-sizing','border-box');rememberSet(x,'min-height',`${height}px`);});
      }
      const top=Math.max(...row.map(x=>x.el.getBoundingClientRect().top));
      row.forEach(({el})=>rememberSet(el,'padding-block-start',`${parseFloat(getComputedStyle(el).paddingBlockStart)+top-el.getBoundingClientRect().top}px`));
      // Equalize address, heading and status+next-opening independently.
      for(const key of ['preface','heading','statusArea']){
        const blocks=row.map(x=>x.el[key]);
        if(blocks.some(x=>!x))continue;
        const height=Math.max(...blocks.map(x=>x.getBoundingClientRect().height));
        blocks.forEach(x=>rememberSet(x,'min-height',`${height}px`));
      }
    }
  }
  function queueAlign(){if(!alignmentFrame)alignmentFrame=requestAnimationFrame(align);}
  window.addEventListener('resize',queueAlign);
  document.addEventListener('load',event=>{if(event.target?.tagName==='IMG')queueAlign();},true);
  document.fonts?.ready.then(queueAlign);
  document.fonts?.addEventListener('loadingdone',queueAlign);
  const observedWidths=new WeakMap();
  const widths=typeof ResizeObserver==='function'?new ResizeObserver(entries=>{
    if(entries.some(({target,contentRect})=>{const old=observedWidths.get(target);observedWidths.set(target,contentRect.width);return old!==contentRect.width;}))queueAlign();
  }):null;

  let sequence=0;
  class OpeningHours extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.timer);
      this.locale=(this.dataset.locale||'de').toLowerCase().split('-')[0];
      if(!copy[this.locale]) this.locale='en';
      this.staticBox=this.querySelector('[data-hours-static]');
      this.liveBox=this.querySelector('[data-hours-live]');
      if(!this.staticBox || !this.liveBox || !Object.hasOwn(branches,this.dataset.branch||'')) return;
      try {this.payload=JSON.parse(this.querySelector('[data-hours-data]')?.textContent||'null');} catch {this.payload={};}
      this.newest=-Infinity;this.ceilings=null;
      if(valid(this.payload,this.payload?.views?.[this.locale],this.dataset.branch,this.locale,Date.now())){
        this.newest=Date.parse(this.payload.fetched_at);
        this.ceilings={expires:Date.parse(this.payload.expires_at),render:Date.parse(this.payload.views[this.locale].render_until)};
      }
      members.add(this);widths?.observe(this);
      this.render();this.schedule();refresh.plan();queueAlign();
    }
    disconnectedCallback(){
      clearTimeout(this.timer);members.delete(this);widths?.unobserve(this);queueAlign();
      if(!members.size){refresh.epoch++;refresh.controller?.abort();refresh.controller=null;clearTimeout(refresh.timer);}
    }
    invalidate(){this.payload=null;this.render();this.schedule();}
    accept(p){
      const now=Date.now(),v=p?.views?.[this.locale],stamp=Date.parse(p?.fetched_at);
      if(Number.isFinite(stamp) && stamp<(this.newest??-Infinity))return false;
      if(!valid(p,v,this.dataset.branch,this.locale,now)){
        // Explicit null from matching markers is authoritative absence. Other invalid
        // responses are failed updates; held data still expires at its original deadline.
        if(p===null)this.invalidate();else{this.render();this.schedule();}
        return false;
      }
      if(stamp===this.newest && (this.ceilings || this.payload?.views?.[this.locale])){
        const limits=this.ceilings||{expires:Date.parse(this.payload.expires_at),render:Date.parse(this.payload.views[this.locale].render_until)};
        // Equal source snapshots cannot prolong the validity of data already held.
        p={...p,expires_at:new Date(Math.min(Date.parse(p.expires_at),limits.expires)).toISOString(),views:{...p.views,[this.locale]:{...v,render_until:new Date(Math.min(Date.parse(v.render_until),limits.render)).toISOString()}}};
        if(!valid(p,p.views[this.locale],this.dataset.branch,this.locale,now))return false;
      }
      this.newest=stamp;this.ceilings={expires:Date.parse(p.expires_at),render:Date.parse(p.views[this.locale].render_until)};this.payload=p;this.render();this.schedule();return true;
    }
    schedule(){
      clearTimeout(this.timer);
      const end=Date.parse(this.payload?.views?.[this.locale]?.render_until);
      const remaining=Math.min(end,Date.parse(this.payload?.expires_at))-Date.now();
      this.timer=setTimeout(()=>this.tick(),remaining>0?Math.min(30000,remaining):30000);
    }
    tick(){this.render();this.schedule();}
    add(tag,text,parent=this.liveBox,cls=''){
      const el=document.createElement(tag);el.textContent=text;if(cls)el.className=cls;parent.append(el);return el;
    }
    render(){
      const p=this.payload,v=p?.views?.[this.locale],c=copy[this.locale],now=Date.now();
      const ok=valid(p,v,this.dataset.branch,this.locale,now);
      const next=ok?nextOpening(v,now):null;
      const red=ok && v.open_now===false && v.time_status==='known' && ((v.state==='closed' && v.business_status==='OPEN') || (v.state==='temporarily_closed' && v.business_status==='CLOSED_TEMPORARILY') || (v.state==='permanently_closed' && v.business_status==='CLOSED_PERMANENTLY'));
      const green=ok && v.state==='open' && v.open_now===true && v.time_status==='known' && v.business_status==='OPEN';
      // Stable DOM at every periodic refresh: disclosure state AND focused node survive.
      const signature=JSON.stringify([ok,ok?v:null,next,green,red]);
      if(signature===this.signature) return;
      this.signature=signature;
      const focused=this.liveBox.contains(document.activeElement),wasToggle=document.activeElement===this.toggle;
      this.expanded=this.expanded||false;
      this.staticBox.hidden=true;this.liveBox.hidden=false;this.liveBox.replaceChildren();
      this.liveBox.dir=this.locale==='ar'?'rtl':'ltr';this.liveBox.lang=this.locale;
      this.liveBox.classList.add('aa-hours');
      // Only status/errors announce; expanding the schedule is not a live-region update.
      this.liveBox.removeAttribute('aria-live');
      const b=branches[this.dataset.branch];
      this.preface=this.add('div','',this.liveBox,'aa-hours__preface');
      if(this.dataset.showAddress!=='false'){
        this.add('p',b.address,this.preface,'aa-hours__address').dir='ltr';
        if(b.extra)this.add('p',b.extra[this.locale],this.preface,'aa-hours__address');
      }
      const heading=this.add('strong',this.dataset.branch==='seefeld-retail'?c.heading:c.title,this.liveBox,'aa-hours__heading');
      heading.tabIndex=-1;this.heading=heading;
      this.statusArea=this.add('div','',this.liveBox,'aa-hours__status-area');
      const status=this.add('p',ok?v.status_text:c.unavailable,this.statusArea,'aa-hours__status');
      status.setAttribute('role','status');status.setAttribute('aria-live','polite');status.setAttribute('aria-atomic','true');
      if(green)status.classList.add('aa-hours__status--open');
      if(red)status.classList.add('aa-hours__status--closed');
      queueAlign();
      if(!ok){if(focused)heading.focus({preventScroll:true});return;}
      if(next)this.add('p',`${c.next}: ${compactDate(next.day.date,this.locale)} · ${next.time}`,this.statusArea,'aa-hours__next');
      const list=this.add('ul','',this.liveBox,'aa-hours__days');
      list.id=this.listId||(this.listId=`aa-hours-days-${++sequence}`);list.setAttribute('aria-label',c.title);
      for(const [n,d] of v.days.entries()){
        const row=this.add('li','',list,'aa-hours__day');
        if(n===0){row.classList.add('aa-hours__day--today');row.setAttribute('aria-current','date');}
        else if(d.source==='regular')row.classList.add('aa-hours__day--regular-future');
        const label=this.add('span','',row,'aa-hours__date');
        if(n===0)this.add('span',c.today,label,'aa-hours__today');
        const date=this.add('time',compactDate(d.date,this.locale),label);
        date.dateTime=d.date;date.setAttribute('aria-label',d.date_label);
        const times=this.add('span','',row,'aa-hours__times');
        if(d.closed)this.add('bdi',d.text,times).dir='auto';
        else for(const i of d.intervals)this.add('bdi',`${i.open}–${i.close}`,times).dir='ltr';
        if(d.source==='special')this.add('span',c.special,row,'aa-hours__special');
      }
      this.toggle=this.add('button','',this.liveBox,'aa-hours__toggle');this.toggle.type='button';
      this.toggle.setAttribute('aria-controls',list.id);
      const update=()=>{list.classList.toggle('aa-hours__days--expanded',this.expanded);this.toggle.setAttribute('aria-expanded',String(this.expanded));this.toggle.textContent=this.expanded?c.less:c.more;};
      this.toggle.addEventListener('click',()=>{this.expanded=!this.expanded;update();});update();
      this.add('p',c.notice,this.liveBox,'aa-hours__notice');
      if(focused)(wasToggle?this.toggle:heading).focus({preventScroll:true});
    }
  }
  customElements.define('aa-google-hours',OpeningHours);
})();

